import { CustomElement } from '@aurelia/runtime-html';
export const name = "pop-over";
export const template = "<template>\n    <a class=\"text-info\">\n        <i class=\"fa fa-info-circle\"></i>\n    </a>\n</template>";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
